import { reactive } from 'vue'

import ymaps from 'yandex-maps'

import paintOnMapModule from '@/modules/DispatcherModule/YmapsModules/paintOnMap'

type StartPaintParams = {
    map: ymaps.Map;
    color: string;
    callback: ({ coordinates, color }: { coordinates: number[][]; color: string }) => void;
}

export default function() {
    let map_instance = null as ymaps.Map | null
    let process = null as any
    let events = null as ymaps.IEventGroup | null
    let callback = ({ coordinates, color }: { coordinates: number[][]; color: string }): void => {
        console.log('default callback on paint finished', coordinates, color)
    }

    const state = reactive({
        is_started: false,
        is_first_map_leave: true,
        color: '#2B55FF',
    })

    const resetState = () => {
        map_instance = null
        events?.removeAll()
        process = null
        callback = ({ coordinates, color }: { coordinates: number[][]; color: string }): void => {
            console.log('default callback on paint finished', coordinates, color)
        }

        state.is_started = false
    
        state.color = '#2B55FF'
        state.is_first_map_leave = true
    }

    const addPaintModule = () => {
        window.ymaps.modules.define(
            'ext.paintOnMap',
            ['meta', 'util.extend', 'pane.EventsPane', 'Event'],
            paintOnMapModule
        )
    }

    function paint(event: any | ymaps.IEvent<Record<any, any>, Record<any, any>>, paintOnMap: any) {
        if (!map_instance) return

        const style = {
            strokeOpacity: 0.2,
            strokeWidth: 0,
            fillOpacity: 0.2,
            strokeColor: state.color,
            fillColor: state.color,
            zIndexHover: 0,
        }

        process = paintOnMap(map_instance, event, { style })
    }

    function stopPaint(event: Record<any, any> | ymaps.IEvent<Record<any, any>, Record<any, any>>) {
        const coordinates = process.finishPaintingAt(event)

        callback({
            coordinates,
            color: state.color,
        })

        resetState()
    }

    function leaveHandler(
        event: Record<any, any> | ymaps.IEvent<Record<any, any>, Record<any, any>>
    ) {
        if (state.is_started && process) {
            if (state.is_first_map_leave) {
                state.is_first_map_leave = false
            } else {
                stopPaint(event)
            }
        }
    }

    const onStartPaint = (params: StartPaintParams) => {
        window.ymaps.modules.require(['ext.paintOnMap']).spread((paintOnMap) => {
            map_instance = params.map
            map_instance.cursors.push('crosshair')
            
            callback = params.callback
            state.color = params.color
            state.is_started = true

            events = map_instance.events
                .group()
                .add('mousedown', (event) => paint(event, paintOnMap))
                .add('mouseup', stopPaint)
                .add('mouseleave', (event) => leaveHandler(event))
        })
    }

    return {
        state,
        addPaintModule,
        onStartPaint,
    }
}